import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-5 py-4 border-b border-slate-200 flex items-center justify-between flex-shrink-0"
};
const _hoisted_2 = {
  class: "text-base font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex items-center gap-2"
};
const _hoisted_4 = {
  key: 0,
  class: "px-5 py-3 border-b border-slate-100 flex-shrink-0"
};
const _hoisted_5 = {
  key: 0,
  class: "flex items-center flex-wrap gap-1.5 mt-2"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "px-5 py-3 border-b border-slate-100 flex-shrink-0"
};
const _hoisted_8 = {
  class: "relative"
};
const _hoisted_9 = {
  class: "flex items-center gap-1 mt-2"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "h-[320px] overflow-y-auto"
};
const _hoisted_12 = {
  key: 0,
  class: "p-8 text-center"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 0,
  class: "flex-shrink-0"
};
const _hoisted_15 = {
  key: 0,
  class: "w-3 h-3 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_16 = {
  class: "flex-1 min-w-0"
};
const _hoisted_17 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_18 = {
  class: "text-sm font-medium text-slate-700 truncate"
};
const _hoisted_19 = {
  class: "text-[11px] text-slate-400 truncate"
};
const _hoisted_20 = {
  key: 1,
  class: "px-5 py-3 border-t border-slate-200 flex items-center justify-between flex-shrink-0"
};
const _hoisted_21 = {
  class: "text-xs text-slate-500"
};
const _hoisted_22 = ["disabled"];
import { ref, computed } from 'vue';
import { useChatStore } from '@/stores/chat';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'NewConversationDialog',
  setup(__props) {
    const chatStore = useChatStore();
    const mode = ref('chat'); // chat | group
    const contactSearch = ref('');
    const contactTab = ref('all');
    const groupName = ref('');
    const groupDescription = ref('');
    const selectedMembers = ref([]);
    const contactTabs = [{
      value: 'all',
      label: '全部'
    }, {
      value: 'internal',
      label: '内部人员'
    }, {
      value: 'customer',
      label: '客户'
    }];
    const filteredContacts = computed(() => {
      let result = chatStore.availableContacts;
      if (contactTab.value !== 'all') {
        result = result.filter(c => c.type === contactTab.value);
      }
      if (contactSearch.value) {
        const keyword = contactSearch.value.toLowerCase();
        result = result.filter(c => c.name.toLowerCase().includes(keyword) || c.department && c.department.toLowerCase().includes(keyword) || c.phone && c.phone.includes(keyword));
      }
      return result;
    });
    const canCreateGroup = computed(() => {
      return groupName.value.trim() && selectedMembers.value.length >= 2;
    });
    function handleSelectContact(contact) {
      chatStore.createNewConversation(contact);
    }
    function toggleMember(contact) {
      const index = selectedMembers.value.findIndex(m => m.id === contact.id);
      if (index > -1) {
        selectedMembers.value.splice(index, 1);
      } else {
        selectedMembers.value.push(contact);
      }
    }
    function isMemberSelected(contact) {
      return selectedMembers.value.some(m => m.id === contact.id);
    }
    function handleCreateGroup() {
      if (!canCreateGroup.value) return;
      chatStore.createNewGroup({
        name: groupName.value.trim(),
        description: groupDescription.value.trim(),
        members: selectedMembers.value
      });
      // 重置状态
      mode.value = 'chat';
      groupName.value = '';
      groupDescription.value = '';
      selectedMembers.value = [];
      contactSearch.value = '';
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: _unref(chatStore).showNewConversationDialog,
        size: "none",
        "panel-class": "w-[480px] max-h-[600px]",
        scrollable: false,
        onClose: _cache[6] || (_cache[6] = $event => _unref(chatStore).showNewConversationDialog = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(mode.value === 'chat' ? '新建会话' : '创建群聊'), 1), _createElementVNode("div", _hoisted_3, [mode.value === 'chat' ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "text-xs text-primary-600 hover:text-primary-700 px-2.5 py-1 rounded-md hover:bg-primary-50 transition-colors cursor-pointer",
          onClick: _cache[0] || (_cache[0] = $event => mode.value = 'group')
        }, " 创建群聊 ")) : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "text-xs text-primary-600 hover:text-primary-700 px-2.5 py-1 rounded-md hover:bg-primary-50 transition-colors cursor-pointer",
          onClick: _cache[1] || (_cache[1] = $event => {
            mode.value = 'chat';
            selectedMembers.value = [];
          })
        }, " 新建单聊 ")), _createElementVNode("button", {
          class: "p-1.5 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
          onClick: _cache[2] || (_cache[2] = $event => _unref(chatStore).showNewConversationDialog = false)
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])])]), mode.value === 'group' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => groupName.value = $event),
          type: "text",
          placeholder: "输入群聊名称...",
          class: "form-input mb-2"
        }, null, 512), [[_vModelText, groupName.value]]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => groupDescription.value = $event),
          type: "text",
          placeholder: "群聊描述（可选）",
          class: "form-input"
        }, null, 512), [[_vModelText, groupDescription.value]]), selectedMembers.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedMembers.value, member => {
          return _openBlock(), _createElementBlock("span", {
            key: member.id,
            class: "inline-flex items-center gap-1 px-2 py-0.5 text-xs bg-primary-50 text-primary-700 rounded-full"
          }, [_createTextVNode(_toDisplayString(member.name) + " ", 1), _createElementVNode("button", {
            class: "p-0.5 hover:bg-primary-100 rounded-full cursor-pointer",
            onClick: $event => toggleMember(member)
          }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
            class: "w-3 h-3",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_6)]);
        }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[9] || (_cache[9] = _createElementVNode("svg", {
          class: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => contactSearch.value = $event),
          type: "text",
          placeholder: "搜索联系人...",
          class: "w-full pl-10 pr-4 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        }, null, 512), [[_vModelText, contactSearch.value]])]), _createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(contactTabs, t => {
          return _createElementVNode("button", {
            key: t.value,
            class: _normalizeClass(["px-2.5 py-1 text-xs rounded-md transition-colors cursor-pointer", contactTab.value === t.value ? 'bg-primary-50 text-primary-600' : 'text-slate-500 hover:bg-slate-50']),
            onClick: $event => contactTab.value = t.value
          }, _toDisplayString(t.label), 11, _hoisted_10);
        }), 64))])]), _createElementVNode("div", _hoisted_11, [filteredContacts.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[10] || (_cache[10] = [_createElementVNode("p", {
          class: "text-sm text-slate-400"
        }, "没有找到匹配的联系人", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredContacts.value, contact => {
          return _openBlock(), _createElementBlock("div", {
            key: contact.id,
            class: "flex items-center gap-3 px-5 py-2.5 hover:bg-slate-50 cursor-pointer transition-colors",
            onClick: $event => mode.value === 'chat' ? handleSelectContact(contact) : toggleMember(contact)
          }, [mode.value === 'group' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", {
            class: _normalizeClass(["w-4 h-4 rounded border-2 flex items-center justify-center transition-colors", isMemberSelected(contact) ? 'bg-primary-500 border-primary-500' : 'border-slate-300'])
          }, [isMemberSelected(contact) ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[11] || (_cache[11] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "3",
            d: "M5 13l4 4L19 7"
          }, null, -1)]))])) : _createCommentVNode("", true)], 2)])) : _createCommentVNode("", true), _createElementVNode("div", {
            class: _normalizeClass(["w-9 h-9 rounded-full flex items-center justify-center text-xs font-medium text-white flex-shrink-0", contact.type === 'internal' ? 'bg-primary-500' : 'bg-emerald-500'])
          }, _toDisplayString(contact.name.slice(-2)), 3), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(contact.name), 1), _createElementVNode("span", {
            class: _normalizeClass(["px-1 py-0.5 text-[10px] leading-none rounded flex-shrink-0", contact.type === 'internal' ? 'bg-primary-100 text-primary-600' : 'bg-emerald-100 text-emerald-600'])
          }, _toDisplayString(contact.type === 'internal' ? '内部' : '客户'), 3)]), _createElementVNode("p", _hoisted_19, _toDisplayString(contact.department ? `${contact.department} · ${contact.position}` : contact.source || contact.phone), 1)])], 8, _hoisted_13);
        }), 128))]), mode.value === 'group' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, "已选 " + _toDisplayString(selectedMembers.value.length) + " 人", 1), _createElementVNode("button", {
          class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg transition-colors cursor-pointer", canCreateGroup.value ? 'bg-primary-500 text-white hover:bg-primary-600' : 'bg-slate-100 text-slate-400 cursor-not-allowed']),
          disabled: !canCreateGroup.value,
          onClick: handleCreateGroup
        }, " 创建群聊 ", 10, _hoisted_22)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};